import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import type { OrganizationViewModelSpecialTermsEnum } from '@trinnvis/dabih-api-client';

export const getSpecialTerms = createSelector(getOrganization, function (organization):
  | OrganizationViewModelSpecialTermsEnum
  | undefined {
  if (organization) {
    if (organization.sector === 'HEALTH') {
      return organization.specialTerms as OrganizationViewModelSpecialTermsEnum;
    } else {
      return undefined;
    }
  }
});
